/** Layout and grid settings per dashboard shell variant. */
export const DASHBOARD_SHELL_VARIANTS = {
  pg: {
    gridVariant: "pg",
    titleFontWeight: 500,
    groupTitleFontWeight: 500,
    responsiveTitle: true,
    shellPadding: { xs: 2, sm: 3 },
  },
  internal: {
    gridVariant: "internal",
    titleFontWeight: 800,
    groupTitleFontWeight: 600,
    responsiveTitle: true,
    shellPadding: { xs: 2, sm: 3 },
  },
  lawFirm: {
    gridVariant: "lawFirm",
    titleFontWeight: 500,
    groupTitleFontWeight: 500,
    responsiveTitle: false,
    shellPadding: 3,
  },
  legacy: {
    titleFontWeight: 800,
    responsiveTitle: false,
    shellPadding: 3,
  },
};
